import { gql } from '@apollo/client';

import { ContactDataFragment } from '../fragments/ContactDataFragment';
import { PartnerBranchFragment } from '../fragments/PartnerBranchFragment';

export type {
  GetPartnerBranches as IGetPartnerBranches,
  GetPartnerBranches_currentPartnerBranch as IPartnerBranchData,
} from './__generated__/GetPartnerBranches';

export const GET_PARTNER_BRANCHES = gql`
  query GetPartnerBranches {
    partnerBranches {
      ...PartnerBranchFragment
    }
    currentPartnerBranch {
      ...PartnerBranchFragment
      partnerManagerContact {
        ...ContactDataFragment
      }
    }
  }
  ${PartnerBranchFragment}
  ${ContactDataFragment}
`;
